import React, { useEffect, useState } from 'react';
import '../../css/Termos.css';
import { db, ANO } from '../../firebase/logar';
import { Link, useNavigate } from 'react-router-dom';
import OneSignal from 'react-onesignal';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, arrowBack, schoolOutline, notificationsOutline, homeOutline, chatbubbleEllipsesOutline, calendarOutline, personOutline } from 'ionicons/icons';

const Notification = () => {
  
  const navigate = useNavigate();

  const back = () => {
    window.history.back();
  }

  useEffect(() => {
        const OneSignalDeferred = window.OneSignalDeferred || [];
        OneSignalDeferred.push(function (OneSignal) {
          OneSignal.init({
            // ID ANTIGO appId: "7639757a-a89b-4b52-8028-7e8b9d328e4c",
            appId: '4f32f773-6836-46ab-b823-c411e07ae41f',
          });
    
          async function pushSubscriptionChangeListener(event) {
            const previousState = event.previous;
            const currentState = event.current;
    
            console.log('Push Subscription Mudou:');
            console.log('ID anterior:', previousState.id);
            console.log('ID atual:', currentState.id);
    
            if (currentState.optedIn === false) {
              console.log('Permissões de push foram negadas ou optOut() foi chamado.');
            } else {
              // Perform actions based on the user's role (RESPONSAVEL, DIRECAO, COORDENACAO)
              const logado = localStorage.getItem('logado');
              const usuario = localStorage.getItem('usuario');
              const responsavel = localStorage.getItem('responsavel');
              const serie = localStorage.getItem('serie');
              
              if (logado === 'RESPONSAVEL') {
                await db.collection(ANO)
                .doc('responsaveis')
                .collection(responsavel)
                .doc(responsavel)
                .update({
                  onesignalId: currentState.id,
                });
                await db.collection(ANO)
                .doc("series")
                .collection(serie)
                .doc(responsavel)
                .update({
                  onesignalId: currentState.id,
                })
              } else {
                const usuarioDocRef = db.collection(ANO)
                .doc('restrito')
                .collection(logado.toLowerCase())
                .doc('login')
                .collection('acessos')
                .doc(usuario);
                usuarioDocRef.get()
                .then((docSnapshot) => {
                    if (docSnapshot.exists) {
                        usuarioDocRef.update({
                            onesignalId: currentState.id,
                        });
                    } else {
                        usuarioDocRef.set({
                            onesignalId: currentState.id,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Erro ao verificar se o documento existe:', error);
                });
              }
    
              if (currentState.token) {
                console.log('Novo token de Push:', currentState.token);
              }
    
              setTimeout(() => {
                window.location.reload();
              }, 5000);
            }
          }
    
          OneSignal.User.PushSubscription.addEventListener('change', pushSubscriptionChangeListener);
        });
  }, []);


  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);

  if (!logado) {
    localStorage.clear();
    navigate('/app/');
  }

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  return (
    <main className="container-termos">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <section className="logo-termos">
        <h1>Aceitar notificações</h1>
        <Link to="/app/person">
            <IonIcon icon={arrowBack} />
        </Link>
        
      </section>

        <div className="permitirNotification">
            <h1>Clique no botão abaixo depois de receber a notificação!</h1>
            <button onClick={() => navigate('/app/')}>Voltar para o aplicativo</button>
        </div>

    </main>
  );
};


export default Notification;